<div class="container">
  <div class="modal-wrapper">
    <div class="recog-h4-bold title">{{ 'NAME_REQUIRED_MODAL_TITLE' | t }}</div>

    <div class="recog-body16 description">{{ 'NAME_REQUIRED_MODAL_DESCRIPTION' | t }}</div>

    <form [formGroup]="nameForm" (ngSubmit)="save()" class="form">
      <ion-item lines="none" class="name-item" [class.invalid]="showMinLengthError || showMaxLengthError">
        <ion-input formControlName="name" type="text" name="name" autocomplete="name" inputmode="text"
          [placeholder]="'NAME' | t" [maxlength]="50" [disabled]="saving" data-test="name-required-modal-input">
        </ion-input>
      </ion-item>

      <div class="error-message recog-body13" *ngIf="showMinLengthError">
        {{ 'NAME_MIN_LENGTH' | t }}
      </div>
      <div class="error-message recog-body13" *ngIf="showMaxLengthError">
        {{ 'NAME_TOO_LONG' | t }}
      </div>
    </form>

    <div class="buttons-container">
      <ion-button class="primary" [disabled]="nameForm.invalid || saving" (click)="save()"
        data-test="name-required-modal-save">
        <span class="button-text" *ngIf="!saving">{{ 'SAVE' | t }}</span>
        <app-loading-spinner *ngIf="saving" [backdrop]="false" size="50" class="customSpinner" [smallSize]="true"
          [size]="'30'"></app-loading-spinner>
      </ion-button>

      <ion-button fill="clear" class="logout-link" [disabled]="saving" (click)="logout()"
        data-test="name-required-modal-logout">
        {{ 'EXIT' | t }}
      </ion-button>
    </div>
  </div>
</div>